import { mdiAccountMultiplePlusOutline, mdiCheckBold, mdiCloseThick, mdiExclamationThick, mdiCreditCardClockOutline,
    mdiSyncOff, mdiDeleteOutline, mdiTableArrowRight,  mdiArrowUpBoldOutline, mdiViewDashboardOutline, mdiAccountGroupOutline,
    mdiStarOutline, mdiAt, mdiEmailSendOutline, mdiChartBoxOutline, mdiLockOutline, mdiAccountGroup,mdiStoreOutline,mdiCalendarStar,
    mdiCalendarRefresh, mdiAccount, mdiPlus, mdiCartOutline, mdiCreditCardOutline, mdiDomain, mdiCogOutline, mdiCheckOutline, mdiCloseOutline,
    mdiHome, mdiContentSaveOutline, mdiHelp, mdiFormTextbox, mdiCash, mdiMapClockOutline, mdiSync, mdiAsterisk, mdiEyeOutline, 
    mdiLogin, mdiCloudTags, mdiCartCheck, mdiContentCopy, mdiMapMarker, mdiEarth, mdiApplication, mdiFacebook, mdiGoogleAnalytics, mdiGoogleAds,
    mdiAlphaSCircle,
    mdiChevronUp,
    mdiChevronDown,
    mdiCurrencyEur,
    mdiImage,
    mdiCard,
    mdiMagnify,
    mdiFormatTitle,
    mdiInbox,
    mdiCog,
    mdiCogs,
    mdiCheckboxBlankCircle,
    mdiLinkLock,
    mdiHomeCityOutline,
    mdiOfficeBuildingMarkerOutline,
    mdiMailboxOutline,
    mdiAccountOutline,
    mdiChevronRight,
    mdiOpenInNew,
    mdiPound,
    mdiFormatListNumbered,
    mdiUpload,
    mdiSale,
    mdiFormatAlignLeft,
    mdiFormatAlignRight,
    mdiFormatAlignCenter,
    mdiFormatAlignJustify,
    mdiFormatBold,
    mdiFormatItalic,
    mdiFormatUnderline,
    mdiChevronLeft,
    mdiEraser,
    mdiArrowVerticalLock,
    mdiArrowHorizontalLock,
    mdiPercentOutline,
    mdiChevronDoubleDown,
    mdiWeb,
    mdiCursorDefaultClickOutline,
    mdiUpdate,
    mdiEmailNewsletter,
    mdiLockOpenOutline,
    mdiCalendarClockOutline,
    mdiCalendarCursor,
    mdiCalendarStart,
    mdiCalendarEnd,
    mdiImageMultipleOutline,
    mdiCurrencyUsd,
    mdiPauseOctagonOutline,
    mdiCheckboxMarkedCircleOutline,
    mdiCheckboxBlankCircleOutline,
    mdiNumeric1,
    mdiNumeric2,
    mdiNumeric3,
    mdiNumeric4,
    mdiNumeric5,
    mdiNumeric6,
    mdiNumeric7,
    mdiNumeric8,
    mdiNumeric9,
    mdiNumeric0,
    mdiArrowExpandUp,
    mdiArrowExpandDown,
    mdiCalendar,
    mdiClockOutline,
    mdiEmailSyncOutline,
    mdiDiamondStone,
    mdiSendClockOutline,
    mdiUnfoldMoreHorizontal,
    mdiBellOutline,
    mdiFormatListCheckbox,
    mdiFormTextboxPassword,
    mdiLogout,
    mdiEye,
    mdiEyeOff,
    mdiFormatListChecks,
    mdiArrowTopRight,
    mdiArrowBottomRight,
    mdiArchiveOutline,
    mdiThermometerHigh,
    mdiThermometer,
    mdiThermometerLow,
    mdiCodeBraces,
    mdiEmailMultipleOutline,
    mdiEmailRemoveOutline,
    mdiReceipt,
    mdiNumeric,
    mdiCancel,
    mdiMinus,
    mdiPhone,
    mdiTranslate,
    mdiTab,
    mdiText,
    mdiFire,
    mdiCookieCheckOutline,
    mdiCodeTags,
    mdiEmailFastOutline,
    mdiHumanGreeting,
    mdiTagOutline,
    mdiProtocol,
    mdiAccountMultipleRemoveOutline,
    mdiAccountRemoveOutline,
    mdiPalette,
    mdiChatQuestion,
    mdiDotsVertical,
    mdiAbTesting,
    mdiTagTextOutline,
    mdiHistory,
    mdiAlphaABox,
    mdiAlphaBBox,
    mdiAlphaCBox,
    mdiAlphaDBox,
    mdiAlphaEBox,
    mdiAlphaFBox,
    mdiAlphaGBox,
    mdiAlphaHBox,
    mdiAlphaIBox,
    mdiAlphaJBox,
    mdiAlphaKBox,
    mdiAlphaMBox,
    mdiAlphaNBox,
    mdiAlphaOBox,
    mdiAlphaPBox,
    mdiAlphaQBox,
    mdiAlphaRBox,
    mdiAlphaSBox,
    mdiAlphaTBox,
    mdiAlphaUBox,
    mdiAlphaVBox,
    mdiAlphaWBox,
    mdiAlphaXBox,
    mdiAlphaYBox,
    mdiAlphaZBox
} from '@mdi/js';


export default {
        importCustomers: mdiAccountMultiplePlusOutline,
        add: mdiPlus,
        up: mdiArrowUpBoldOutline,
        ok: mdiCheckBold,
        nok: mdiCloseThick,
        ok_outline: mdiCheckOutline,
        nok_outline: mdiCloseOutline,
        warn: mdiExclamationThick,
        paymentDue: mdiCreditCardClockOutline,
        active: mdiSync,
        inactive: mdiSyncOff,
        purged: mdiDeleteOutline,
        feed: mdiTableArrowRight,
        dashboard: mdiViewDashboardOutline,
        tracking: mdiAccountGroupOutline,
        box: mdiStarOutline,
        mailing: mdiAt,
        campaign: mdiCurrencyUsd,
        stats: mdiChartBoxOutline,
        access: mdiLockOutline,
        visitors: mdiAccountGroup,
        productFeed: mdiCloudTags,
        recommendationsUpdate: mdiCalendarStar,
        productsUpdate: mdiCalendarRefresh,
        profile: mdiAccount,
        domain: mdiStoreOutline,
        cart: mdiCartOutline,
        billing: mdiCreditCardOutline,
        business: mdiDomain,
        settings: mdiCogOutline,
        company: mdiDomain,
        home: mdiHome,
        save: mdiContentSaveOutline,
        help: mdiHelp,
        name: mdiFormTextbox,
        currency: mdiCash,
        sales: mdiCash,
        timezone: mdiMapClockOutline,
        integrations: mdiSync,
        required: mdiAsterisk,
        optional: mdiHelp,
        view: mdiEyeOutline,
        signIn: mdiLogin,
        purchase: mdiCartCheck,
        copy: mdiContentCopy,
        address: mdiMapMarker,
        country: mdiEarth,
        plan: mdiAccountGroupOutline,
        subscription: mdiCreditCardClockOutline,
        platform: mdiApplication,
        fb: mdiFacebook,
        ganalytics: mdiGoogleAnalytics,
        gadwords: mdiGoogleAds,
        sklik: mdiAlphaSCircle,
        upList: mdiChevronUp,
        downList: mdiChevronDown,
        price: mdiCurrencyEur,
        image: mdiImage,
        button: mdiCard,
        description: mdiMagnify,
        title: mdiFormatTitle,
        empty: mdiInbox,
        advanced: mdiCogs,
        basic:  mdiCog,
        colorPreview: mdiCheckboxBlankCircle,
        remove: mdiDeleteOutline,
        shareAccess: mdiLinkLock,
        send: mdiEmailSendOutline,
        street: mdiOfficeBuildingMarkerOutline,
        city: mdiHomeCityOutline,
        zip: mdiMailboxOutline,
        refresh: mdiSync,
        visitor: mdiAccountOutline,
        next: mdiChevronRight,
        openInNew: mdiOpenInNew,
        hash: mdiPound,
        rows: mdiFormatListNumbered,
        upload: mdiUpload,
        sale: mdiSale,
        textAlignLeft: mdiFormatAlignLeft,
        textAlignRight: mdiFormatAlignRight,
        textAlignCenter: mdiFormatAlignCenter,
        textAlignJustify: mdiFormatAlignJustify,
        textBold: mdiFormatBold,
        textItalic: mdiFormatItalic,
        textUnderline: mdiFormatUnderline,
        collapseLeft: mdiChevronLeft,
        expandRight: mdiChevronRight,
        setup: mdiCogs,
        settingsDark: mdiCog,
        clear: mdiEraser,
        lockVertical:mdiArrowVerticalLock,
        lockHorizontal:mdiArrowHorizontalLock,
        percent:mdiPercentOutline,
        extendDown:mdiChevronDoubleDown,
        dnsDomain: mdiWeb,
        dnsMailFrom: mdiEmailSendOutline,
        dnsTracking: mdiCursorDefaultClickOutline,
        pending: mdiUpdate,
        newsletterTemplate: mdiEmailNewsletter,
        locked: mdiLockOutline,
        unlocked: mdiLockOpenOutline,
        generate: mdiCogs,
        scheduled: mdiCalendarClockOutline,
        choose: mdiCheckOutline,
        selected: mdiCheckBold,
        rename: mdiFormTextbox,
        calendarChoose: mdiCalendarCursor,
        calendarFrom: mdiCalendarStart,
        calendarTo: mdiCalendarEnd,
        templateGallery: mdiImageMultipleOutline,
        pause: mdiPauseOctagonOutline,
        filterInactive: mdiCheckboxBlankCircleOutline,
        filterActive: mdiCheckboxMarkedCircleOutline,
        num1: mdiNumeric1,
        num2: mdiNumeric2,
        num3: mdiNumeric3,
        num4: mdiNumeric4,
        num5: mdiNumeric5,
        num6: mdiNumeric6,
        num7: mdiNumeric7,
        num8: mdiNumeric8,
        num9: mdiNumeric9,
        num0: mdiNumeric0,
        recommendation: mdiStarOutline,
        segmentFrom: mdiArrowExpandDown,
        segmentTo: mdiArrowExpandUp,
        segment: mdiAccountGroupOutline,
        date: mdiCalendar,
        time: mdiClockOutline,
        messageFrequency: mdiEmailSyncOutline,
        messageDelay: mdiSendClockOutline,
        premium: mdiDiamondStone,
        changePriority: mdiUnfoldMoreHorizontal,
        notifications: mdiBellOutline,
        password: mdiFormTextboxPassword,
        todo: mdiFormatListCheckbox,
        logout: mdiLogout,
        showPassword: mdiEye,
        hidePassword: mdiEyeOff,
        overview: mdiFormatListChecks,
        trendUp: mdiArrowTopRight,
        trendDown: mdiArrowBottomRight,
        archive: mdiArchiveOutline,
        leadscoreHot: mdiThermometerHigh,
        leadscoreWarm: mdiThermometer,
        leadscoreCold: mdiThermometerLow,
        json: mdiCodeBraces,
        refreshed: mdiUpdate,
        sentTotal: mdiEmailMultipleOutline,
        unsubscribed: mdiEmailRemoveOutline,
        importOrders: mdiReceipt,
        crNo: mdiNumeric,
        search: mdiMagnify,
        blocked: mdiCancel,
        helpdesk: mdiFormatListChecks,
        collapse: mdiChevronUp,
        //expand: mdiChevronDown,
        plus: mdiPlus,
        minus: mdiMinus,
        phone: mdiPhone,
        customizations: mdiTranslate,
        tab: mdiTab,
        heading:mdiFormatTitle,
        text:mdiText,
        swu:mdiFire,
        cookie: mdiCookieCheckOutline,
        trackingCode: mdiCodeTags,
        runningCampaigns: mdiEmailFastOutline,
        emailRecipients: mdiEmailFastOutline,
        welcome: mdiHumanGreeting,
        tag: mdiTagOutline,
        form: mdiFormTextbox,
        url: mdiProtocol,
        unsubscribeBatch: mdiAccountMultipleRemoveOutline,
        unsubscribe: mdiAccountRemoveOutline,
        color: mdiPalette,
        supportChat: mdiChatQuestion,
        menu: mdiDotsVertical,
        variants: mdiAbTesting,
        subject: mdiTagTextOutline,
        history: mdiHistory,
        campaignVariantA: mdiAlphaABox,
        campaignVariantB: mdiAlphaBBox,
        campaignVariantC: mdiAlphaCBox,
        campaignVariantD: mdiAlphaDBox,
        campaignVariantE: mdiAlphaEBox,
        campaignVariantF: mdiAlphaFBox,
        campaignVariantG: mdiAlphaGBox,
        campaignVariantH: mdiAlphaHBox,
        campaignVariantI: mdiAlphaIBox,
        campaignVariantJ: mdiAlphaJBox,
        campaignVariantK: mdiAlphaKBox,
        campaignVariantM: mdiAlphaMBox,
        campaignVariantN: mdiAlphaNBox,
        campaignVariantO: mdiAlphaOBox,
        campaignVariantP: mdiAlphaPBox,
        campaignVariantQ: mdiAlphaQBox,
        campaignVariantR: mdiAlphaRBox,
        campaignVariantS: mdiAlphaSBox,
        campaignVariantT: mdiAlphaTBox,
        campaignVariantU: mdiAlphaUBox,
        campaignVariantV: mdiAlphaVBox,
        campaignVariantW: mdiAlphaWBox,
        campaignVariantX: mdiAlphaXBox,
        campaignVariantY: mdiAlphaYBox,
        campaignVariantZ: mdiAlphaZBox,

}